import { render, staticRenderFns } from "./AsignaPersonalDialogComponent.vue?vue&type=template&id=dc3ca180"
import script from "./AsignaPersonalDialogComponent.vue?vue&type=script&lang=js"
export * from "./AsignaPersonalDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports